import { AddBox, Reorder } from '@mui/icons-material';
import LayautContext from 'Context/ContextLayaut';
import React, { useState, useEffect, useContext } from 'react';
import { ModalGeneral, Tabla } from 'ui-component';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import ServiciosPlantilla from './ServiciosPlantilla';
import FormPreguntasActividad from '../../../catalogo/Cursos/components/FormPreguntasActividad';
import FormOrdenar from '../../../catalogo/Cursos/components/FormOrdenar';
import { Grid, Typography } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';

const Item = styled(Typography)(({ theme }) => ({
    ...theme.typography.body1,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));
const useStyles = makeStyles((theme) => ({
    respuestaCorrecta: {
        background: theme.palette.success.main,
        border: 0,
        borderRadius: 3,
        color: 'white'
    }
}));
const columns = [
    { label: 'Pregunta', name: 'npregunta', filtrar: true },
    {
        label: 'Tipo',
        name: 'ntipoPregunta',
        filtrar: {
            id: 'idTipoPregunta',
            value: 'ntipoPregunta',
            ctl: [
                { idTipoPregunta: '0', ntipoPregunta: 'Abierta' },
                { idTipoPregunta: '1', ntipoPregunta: 'Cerrada' }
            ]
        }
    }
];

const aliasRespuestasEntrada = (preguntas = []) =>
    preguntas.map((p) => ({
        ...p,
        respuestas: Array.isArray(p.respuestas) ? p.respuestas.map((r) => ({ ...r, idRespuesta: r.idPlantillaRespuesta })) : p.respuestas
    }));

const aliasRespuestasSalida = (respuestas = []) => respuestas.map((r) => ({ ...r, idPlantillaRespuesta: r.idRespuesta }));

const ModalPreguntasPlantilla = ({ plantilla, permisos, onCambio }) => {
    const classes = useStyles();
    const context = useContext(LayautContext);
    const servicios = ServiciosPlantilla();
    const [pregunta, setPregunta] = useState([]);
    const [modalEliminarPregunta, setModalEliminarPregunta] = useState({ open: false, text: '' });

    const actualizarData = (nuevaPregunta = []) => {
        const filtradas = (nuevaPregunta || []).filter((x) => x.estatus != -1);
        setPregunta(aliasRespuestasEntrada(filtradas));
    };

    const abrirNuevoPregunta = () => () =>
        context.formulario.abrir({
            open: true,
            titulo: 'Nueva pregunta',
            formulario: FormPreguntasActividad,
            aceptar: (data) => {
                if (pregunta.find((prg) => prg.npregunta.trim() == data.npregunta.trim()))
                    return context.mensaje({ open: true, status: 0, value: 'La pregunta ya ha sido registrada previamente' });

                servicios.insertPreguntaPlantilla(
                    (res) => {
                        if (onCambio) onCambio(res);
                        actualizarData(res.pregunta);
                        context.formulario.cerrar();
                    },
                    {
                        ...data,
                        respuestas: aliasRespuestasSalida(data.respuestas || []),
                        idPlantilla: plantilla.idPlantilla,
                        idTipoPregunta: data.idTipoPregunta == '1'
                    }
                );
                return true;
            }
        });

    const abrirEditarPregunta = (preguntaUpdate) => {
        context.formulario.abrir({
            open: true,
            titulo: `Editar la pregunta ${preguntaUpdate.npregunta}`,
            formulario: FormPreguntasActividad,
            propsForm: { data: { ...preguntaUpdate, idTipoPregunta: preguntaUpdate.idTipoPregunta == '1' } },
            aceptar: (data) => {
                if (
                    pregunta.find(
                        (prg) =>
                            prg.idPlantillaPregunta != preguntaUpdate.idPlantillaPregunta && prg.npregunta.trim() == data.npregunta.trim()
                    )
                )
                    return context.mensaje({ open: true, status: 0, value: 'La pregunta ya ha sido registrada previamente' });

                servicios.updatePreguntaPlantilla(
                    (res) => {
                        if (onCambio) onCambio(res);
                        actualizarData(res.pregunta);
                        context.formulario.cerrar();
                    },
                    {
                        ...data,
                        respuestas: aliasRespuestasSalida(data.respuestas || []),
                        idPlantillaPregunta: preguntaUpdate.idPlantillaPregunta,
                        idPlantilla: plantilla.idPlantilla,
                        idTipoPregunta: data.idTipoPregunta == '1'
                    }
                );
                return true;
            }
        });
    };

    const abrirEliminarPregunta = (accion) => (preguntaSel) => {
        let texto = '';
        switch (accion) {
            case 0:
                texto = `¿Estás seguro de desactivar la pregunta "${preguntaSel.npregunta}"?`;
                break;
            case 1:
                texto = `¿Estás seguro de volver a activar la pregunta "${preguntaSel.npregunta}"?`;
                break;
            case -1:
                texto = `La pregunta "${preguntaSel.npregunta}" ya no estará disponible en esta plantilla. ¿Desea continuar?`;
                break;
        }
        setModalEliminarPregunta({
            open: true,
            text: texto,
            aceptar: () =>
                servicios.cambiarEstatusPreguntaPlantilla(
                    (res) => {
                        if (onCambio) onCambio(res);
                        actualizarData(res.pregunta);
                        setModalEliminarPregunta({ ...modalEliminarPregunta, open: false });
                    },
                    { idPlantillaPregunta: preguntaSel.idPlantillaPregunta, idPlantilla: plantilla.idPlantilla, estatus: accion }
                )
        });
    };

    const abrirOrdenar = () => () => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: 'Ordenar Preguntas',
            propsForm: { data: { dataOrden: pregunta }, ctl: {} },
            formulario: FormOrdenar,
            aceptar: (dataForm) => {
                if (dataForm.dataOrdenada == undefined) return context.mensaje({ open: true, value: 'No se ha hecho ningún orden' });
                servicios.updateOrdenPreguntaPlantilla(
                    (res) => {
                        if (onCambio) onCambio(res);
                        actualizarData(res.pregunta);
                        context.formulario.cerrar();
                    },
                    { dataOrdenada: dataForm.dataOrdenada, idPlantilla: plantilla.idPlantilla }
                );
                return true;
            }
        });
    };

    const accionesTabla = [
        { label: 'Nueva pregunta', icon: <AddBox />, click: abrirNuevoPregunta, disabled: !permisos.crear },
        { label: 'Ordenar preguntas', icon: <Reorder />, click: abrirOrdenar, disabled: !permisos.editarPregunta }
    ];
    const accionesFila = [
        { label: 'Editar', onClick: abrirEditarPregunta, enabled: (p) => permisos.editarPregunta && p.estatus == '1' },
        { label: 'Desactivar Pregunta', onClick: abrirEliminarPregunta(0), enabled: (p) => permisos.editarPregunta && p.estatus == '1' },
        {
            label: 'Volver activar Pregunta',
            onClick: abrirEliminarPregunta(1),
            enabled: (p) => permisos.editarPregunta && p.estatus == '0'
        },
        { label: 'Eliminar pregunta', onClick: abrirEliminarPregunta(-1), enabled: true }
    ];

    useEffect(() => {
        actualizarData(plantilla?.preguntas || []);
    }, [plantilla]);

    return (
        <>
            <Tabla
                rows={pregunta}
                columns={columns}
                onError={(cst) => cst.estatus != 1}
                accionesTabla={accionesTabla}
                accionesFila={accionesFila}
                columnKey="idPlantillaPregunta"
                DetailByrow={(row) => (
                    <Grid container spacing={2}>
                        {row?.respuestas?.map((rsp) => (
                            <Grid item xs={3} key={rsp.idRespuesta || rsp.nrespuesta}>
                                <Item
                                    className={rsp.isCorrecta == '1' ? classes.respuestaCorrecta : null}
                                    color="purple"
                                >{`R- ${rsp.nrespuesta}`}</Item>
                            </Grid>
                        ))}
                    </Grid>
                )}
            />
            <AvisoConfirmacion
                open={modalEliminarPregunta.open}
                title="Advertencia"
                text={modalEliminarPregunta.text}
                accept={modalEliminarPregunta.aceptar}
                cancel={() => setModalEliminarPregunta({ ...modalEliminarPregunta, open: false })}
            />
        </>
    );
};

export default ModalPreguntasPlantilla;
